import { Spacer } from '@porsche-code/kado-ui';
import { PHeading } from '@porsche-design-system/components-react';
import { createFileRoute } from '@tanstack/react-router';
import { Trans, useTranslation } from 'react-i18next';

import {
  AdditionalOrganizationOverview,
  CreateAdditionalOrganization,
} from './-components';

export const Route = createFileRoute('/admin/user-management/_auth/')({
  component: UserManagement,
  beforeLoad: () => {
    return {
      breadcrumb: () => <Trans i18nKey="admin.userManagement.headline" />,
    };
  },
});

function UserManagement() {
  const { t } = useTranslation();

  return (
    <>
      <PHeading size="lg" aria-level={1} tag="h1">
        {t('admin.userManagement.headline')}
      </PHeading>
      <Spacer mb="md" />
      <CreateAdditionalOrganization />
      <Spacer mb="lg" />
      <AdditionalOrganizationOverview />
    </>
  );
}
